import React from 'react'
import ImageNotAvailable from '../../../assets/image-not-available.png'
import CloseIcon from '../../../assets/Content-Icons/Svgs/close-circled.svg'
import CustomImage from 'src/components/customImage/customImage'

const FormPreview = ({
  onClose = {},
  cardImage = '',
  headline = '',
  subHeadline = '',
  basicInfo = [],
  width = '50%',
  disableAnimation = false,
  disableDataHeight = false,
}) => {
  return (
    <div
      style={{ width: width, zIndex: '30' }}
      className={`preview-slider ${!disableAnimation && 'preview-slider-animation'} `}
    >
      <div
        className=" p-3 d-flex flex-column justify-content-center align-items-start h-100 rounded-2"
        style={{
          background: '#ebe9e9',
          width: '40%',
        }}
      >
        <div className="mb-auto">
          <img src={CloseIcon} alt="" onClick={onClose} role="button" />
        </div>
        <div className="w-100 mb-auto relative">
          <CustomImage
            className="card-img-top"
            imageUrl={cardImage}
            loaderStyle={{ height: '100%' }}
            errorPlaceholder={ImageNotAvailable}
            alt={'Asset'}
            imgStyle={{ height: '100%', width: '100%' }}
          />
        </div>
      </div>
      <div
        className="custom-scrollbar-vertical "
        style={{
          padding: '18px 23px 0 25px',
          width: '60%',
          overflowX: 'hidden',
        }}
      >
        <div className=" h-100">
          <div className="text-right">
            <h5
              style={{
                color: '#191818',
                fontSize: '30px',
                fontWeight: '700',
              }}
            >
              {headline}
            </h5>
            <p style={{ fontSize: '14px' }}>{subHeadline}</p>
          </div>
          <div
            style={{ height: disableDataHeight ? '' : '75%' }}
            className=" d-flex align-items-center "
          >
            <div className="w-100">
              {/* for data */}

              <div className="tabular-div">
                {[...basicInfo].map((info, idx) => (
                  <div className="d-flex mt-1" key={idx}>
                    <p style={{ width: '40%' }} className="tabular-div-headings">
                      {info.property}
                    </p>
                    <p style={{ width: '60%' }} className="tabular-div-data">
                      {info.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormPreview
